export enum TYPES {
  TEXT,
  LIST,
}

export default [
  {
    key: 1,
    question: 'Can I submit my poster and/or presentation if I am not presenting at a conference?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'Yes, the new workflow to publish on SciMeetings allows you to submit your early stage research artifacts even if you are not presenting at a conference hosted on SciMeetings.',
      },
    ],
  },
  {
    key: 2,
    question: 'Will my submission be reviewed by SciMeetings?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'If you are presenting at an American Chemical Society affiliated conference or were selected as a presenter of a conference that is a SciMeetings partner, you can submit your poster or presentation directly on SciMeetings once you complete the SciMeetings sign-up as part of your registration process. No additional review will be needed as the conference organizers would have already completed the review. The cost for submissions affiliated with an American Chemical Society conference or SciMeetings selected partner conference depends on the meeting organizers and will be available on those meeting websites when appropriate.',
      },
      {
        type: TYPES.TEXT,
        content:
          'If you are submitting to SciMeetings independent of a conference, your poster or presentation will be reviewed by the SciMeetings team after you submit. Upon approval, your poster or presentation and additional documents will be live on the platform once the payment is processed (no additional work needed on your end). If your abstract or poster presentation is not approved, you will not be charged the hosting fee by SciMeetings. The cost for accepted submissions is $150. If you are an ACS Premium Member, you are entitled to a discount. Check your email for your ACS Premium Member discount code.',
      },
    ],
  },
  {
    key: 3,
    question: 'Why are PDFs the only file type accepted for posters and presentations?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'The  Portable  Document  Format  (PDF)  is  a  universally  accepted  format  for  document  display independent  of  application  software,  hardware,  and  operating  system.  This  is  the  best  way  to ensure your poster or presentation is presented exactly as you crafted it, whether viewed on a monitor, tablet, or mobile device. PDFs also facilitate download and offline viewing of your work. While the primary poster or presentation must be in PDF format, supporting materials can be in their native formats (see below).',
      },
    ],
  },
  {
    key: 4,
    question:
      'What types of metadata or supporting files can be uploaded and how are they viewable on SciMeetings?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'SciMeetings accepts posters or presentations in PDF format. Title, author, affiliation, keywords, and abstract are captured and viewable on SciMeetings.',
      },
      {
        type: TYPES.TEXT,
        content:
          'Additional files may be uploaded as supporting information. The following file formats are supported (with a maximum file size of 150 MB):',
      },
      {
        type: TYPES.LIST,
        content: [
          'Images – jpg, png, bmp',
          'Audio – mp3',
          'Video – mp4',
          'Data – csv, xls',
          'Other – PDF',
        ],
      },
    ],
  },
  {
    key: 5,
    question: 'What are the benefits to authors who upload their posters and presentations?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'Posters and presentations uploaded to SciMeetings will receive a DOI from ACS Publications, the publisher of record. DOIs ensure your work can be easily cited by others and establish a permanent record of your contribution to the scientific record. You can track views, downloads, and citations in your registered SciMeetings account.',
      },
      {
        type: TYPES.TEXT,
        content:
          'The standard license for work submitted to SciMeetings is CC BY-NC-ND. This license allows others to download your work and share it as long as they credit you, but they can’t change your work in any way or use it commercially.',
      },
    ],
  },
  {
    key: 6,
    question:
      'Does posting on SciMeetings count as a prior publication when I publish my work later?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'The Editors-in-Chief of ACS journals have agreed that inclusion of posters and presentations on SciMeetings is comparable with posting on a preprint server, and as such does not constitute prior publication.  As  with  preprints,  we  recommend  that  you  inform  the  Editors  about  conference materials posted on SciMeetings and their relationship to your submitted manuscript in the cover letter. If you plan to submit your work to a non-ACS journal at a later time, you should verify with the  Publisher  and/or  Editor  that  inclusion  of  your  conference  material  on  SciMeetings  is acceptable.',
      },
    ],
  },
  {
    key: 7,
    question: 'What does it mean for my conference materials to be private?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'Posting your work privately means it cannot be seen by anyone and is therefore ineligible for a DOI or CC BY-NC-ND license. Your work will simply be archived in the cloud.',
      },
    ],
  },
  {
    key: 8,
    question: 'Can my co-authors be added to the conference materials?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'Yes, you can add any co-authors to your conference materials by adding their name and email address when submitting your poster or presentation.',
      },
    ],
  },
  {
    key: 9,
    question: 'Why did ACS Publications select Morressier as the SciMeetings platform provider?',
    answer: [
      {
        type: TYPES.TEXT,
        content:
          'Morressier was selected as the platform for SciMeetings due to their commitment to developing tools that enable conference posters, presentations, abstracts, datasets, videos, and supporting files to be widely discoverable. Morressier actively pursues new functionality to ensure users have the best possible experience. Research you post on SciMeetings is searchable on the SciMeetings platform.',
      },
    ],
  },
];
